// extracted by mini-css-extract-plugin
module.exports = {"search_container":"style_search_container__2wzNB","back_btn":"style_back_btn__27-hz"};